import type { MessageKey } from '../../../configuration';
import { getFreeTrialConfig, getProductIconUrl } from '../config/productConfig';

export interface FreeTrialProductInfo {
    productId: string;
    productName: string;
    shortExplanationId: MessageKey;
    longExplanationId: MessageKey;
    level?: string;
    iconUrl: string;
}

const FREE_TRIAL_PRODUCT_DEFINITIONS = [
    {
        productId: 'rio-sku00000047',
        shortExplanationId: 'marketplace.freeTrial.product.geo.short',
        longExplanationId: 'marketplace.freeTrial.product.geo.long',
    },
    {
        productId: 'rio-sku00000027',
        shortExplanationId: 'marketplace.freeTrial.product.timed.short',
        longExplanationId: 'marketplace.freeTrial.product.timed.long',
    },
    {
        productId: 'man-sku00000004',
        shortExplanationId: 'marketplace.freeTrial.product.compliant.short',
        longExplanationId: 'marketplace.freeTrial.product.compliant.long',
    },
    {
        productId: 'man-sku00000005',
        shortExplanationId: 'marketplace.freeTrial.product.perform.short',
        longExplanationId: 'marketplace.freeTrial.product.perform.long',
    },
    {
        productId: 'man-sku00000049',
        shortExplanationId: 'marketplace.freeTrial.product.servicecarem.short',
        longExplanationId: 'marketplace.freeTrial.product.servicecarem.long',
    },
    {
        productId: 'man-sku00000050',
        shortExplanationId: 'marketplace.freeTrial.product.emanagerm.short',
        longExplanationId: 'marketplace.freeTrial.product.emanagerm.long',
    },
    {
        productId: 'man-sku00000066',
        shortExplanationId: 'marketplace.freeTrial.product.simplepay.short',
        longExplanationId: 'marketplace.freeTrial.product.simplepay.long',
    },
] as const;

export const FREE_TRIAL_PRODUCTS: FreeTrialProductInfo[] = FREE_TRIAL_PRODUCT_DEFINITIONS.map(product => {
    const freeTrialConfig = getFreeTrialConfig(product.productId);
    const iconUrl = getProductIconUrl(product.productId);

    if (!freeTrialConfig || !iconUrl) {
        throw new Error(`Missing free trial product config for ${product.productId}`);
    }

    return {
        productId: product.productId,
        productName: freeTrialConfig.productName,
        level: freeTrialConfig.level,
        shortExplanationId: product.shortExplanationId,
        longExplanationId: product.longExplanationId,
        iconUrl,
    };
});
